import {
    useClarificationHistory,
    type ClarificationHistoryResult,
    type ConversationKind
} from './useClarificationHistory';

export const REFINEMENT_CONVERSATION_QUERY_PREFIX = 'refinement-design-conversation';
export const REFINEMENT_REVISION_EVENT_TYPE = 'request-refinement-design-revision';
export const REFINEMENT_RESUBMISSION_EVENT_TYPES = [
    'submit-refinement-for-design',
    'refinement-design-pre-approved'
];
export const REFINEMENT_LABEL_OVERRIDES: Partial<Record<ConversationKind, string>> = {
    revision: 'Revision requested',
    'clarification-requested': 'ODO asked for clarification',
    'clarification-provided': 'Doctor answered'
};

// Threads the Ref-6.1 (GP or orthodontist revision request) <-> Ref-3 (ODO resubmission) loop
// into one chronological conversation, scoped to the current refinement cycle.
export function useRefinementDesignConversation(
    patientId: string,
    since: string | null
): ClarificationHistoryResult {
    return useClarificationHistory(REFINEMENT_CONVERSATION_QUERY_PREFIX, patientId, {
        revisionEventType: REFINEMENT_REVISION_EVENT_TYPE,
        resubmissionEventTypes: REFINEMENT_RESUBMISSION_EVENT_TYPES,
        since
    });
}
